import { MenuProps } from "antd";
import { Link } from "react-router-dom";
import ROUTES from "../../routes";
import Icon from "../Icon/Icon";

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

const Dashboard = getItem(
  <Link to={ROUTES.PATHS.ADMIN.HOME}>Dashboard</Link>,
  ROUTES.PATHS.ADMIN.HOME,
  <Icon icon="dashboard" className="h-4 w-4" />,
);
const SalesData = getItem(
  <Link to={ROUTES.PATHS.ADMIN.SALESDATA}>Sales Data</Link>,
  ROUTES.PATHS.ADMIN.SALESDATA,
  <Icon icon="salesdata" className="h-4 w-4" />,
);
const Catalog = ({ admin }: { admin?: boolean } = { admin: false }) =>
  getItem("Catalog", "sub1", <Icon icon="catalog" className="h-4 w-4" />, [
    getItem(
      <Link to={ROUTES.PATHS.ADMIN.TRACKS}>Tracks</Link>,
      ROUTES.PATHS.ADMIN.TRACKS,
    ),
    getItem(
      <Link to={ROUTES.PATHS.ADMIN.LABELS}>Labels</Link>,
      ROUTES.PATHS.ADMIN.LABELS,
    ),
    getItem(
      <Link to={ROUTES.PATHS.ADMIN.ARTISTS}>Artists</Link>,
      ROUTES.PATHS.ADMIN.ARTISTS,
    ),
    getItem(
      <Link to={ROUTES.PATHS.ADMIN.LYRICISTS}>Lyricists</Link>,
      ROUTES.PATHS.ADMIN.LYRICISTS,
    ),
    getItem(
      <Link to={ROUTES.PATHS.ADMIN.COMPOSERS}>Composers</Link>,
      ROUTES.PATHS.ADMIN.COMPOSERS,
    ),
    ...(admin
      ? [
          getItem(
            <Link to={ROUTES.PATHS.ADMIN.PLATFORM}>Platforms</Link>,
            ROUTES.PATHS.ADMIN.PLATFORM,
          ),
          getItem(
            <Link to={ROUTES.PATHS.ADMIN.DISTRIBUTOR}>Distributors</Link>,
            ROUTES.PATHS.ADMIN.DISTRIBUTOR,
          ),
        ]
      : []),
  ]);
const Clients = getItem(
  <Link to={ROUTES.PATHS.ADMIN.CLIENTS}>Clients</Link>,
  ROUTES.PATHS.ADMIN.CLIENTS,
  <Icon icon="clients" className="h-4 w-4" />,
);
const Payments = getItem(
  <Link to={ROUTES.PATHS.ADMIN.PAYMENTS}>Payments</Link>,
  ROUTES.PATHS.ADMIN.PAYMENTS,
  <Icon icon="payments" className="h-4 w-4" />,
);
const Invoices = getItem(
  <Link to={ROUTES.PATHS.ADMIN.INVOICES}>Invoices</Link>,
  ROUTES.PATHS.ADMIN.INVOICES,
  <Icon icon="invoices" className="h-4 w-4" />,
);
const Reports = getItem(
  "Report",
  "sub2",
  <Icon icon="reports" className="h-4 w-4" />,
  [
    getItem(
      <Link to={ROUTES.PATHS.ADMIN.INCOME}>Reports</Link>,
      ROUTES.PATHS.ADMIN.INCOME,
    ),
  ],
);
const SignupRequests = getItem(
  <Link to={ROUTES.PATHS.ADMIN.SIGNUP_REQUESTS}>Signup Requests</Link>,
  ROUTES.PATHS.ADMIN.SIGNUP_REQUESTS,
  <Icon icon="signup" className="h-4 w-4" />,
);
const Users = getItem(
  <Link to={ROUTES.PATHS.ADMIN.USERS}>Users</Link>,
  ROUTES.PATHS.ADMIN.USERS,
  <Icon icon="users" className="h-4 w-4" />,
);
const Settings = getItem(
  <Link to={ROUTES.PATHS.ADMIN.SETTINGS}>Settings</Link>,
  ROUTES.PATHS.ADMIN.SETTINGS,
  <Icon icon="settings" className="h-4 w-4" />,
);

export const clapAdminManagerItems: MenuItem[] = [
  Dashboard,
  SalesData,
  Catalog({ admin: true }),
  Clients,
  Invoices,
  Payments,
  Reports,
  Users,
  SignupRequests,
  Settings,
];

export const accountsItems: MenuItem[] = [
  Catalog(),
  Payments,
  Reports,
  Settings,
];

export const managerItems: MenuItem[] = [Catalog(), Settings];
